export default "__VITE_ASSET__miYnNHaY__"